export default {
  keywordsTableData: state => state.keywordsTableData,
  summary: state => state.summary,
  topKeywords: state => state.topKeywords,
  keywords: state => state.keywords,
  keywordByDate: state => state.keywordByDate,
  loading: state => state.loading,
  pagination: state => state.pagination,
  searchStats: state => state.searchStats,
  ordering: state => state.ordering,
  keywordsNextPage: state => state.keywordsNextPage,
  loadingMoreKeywords: state => state.loadingMoreKeywords,
  filters: state => state.filters
};
